import { configureStore } from '@reduxjs/toolkit';
import user from './user/reducer';
import appTrack from './appTrack/reducer';
import fundingAdmin from './fundingAdmin/reducer';
import staticPages from './staticPages/reducer';
import forms from './forms/reducer';
import adminPanel from './adminPanel/reducer';
import activeForm from './activeForm/reducer';
import funding from './funding/reducer';
import fundingPrograms from './fundingPrograms/reducer';
import { getExpiry, loadState, saveState } from 'utils/localStorage';
import { clearMapDetails } from './staticPages/actions';

const persistedState = loadState();

export const store = configureStore({
  reducer: {
    activeForm,
    user,
    forms,
    appTrack,
    fundingAdmin,
    staticPages,
    adminPanel,
    funding,
    fundingPrograms,
  },
  preloadedState: persistedState,
  devTools:
    process.env.ENVIRONMENT !== 'production' &&
    process.env.NODE_ENV !== 'production',
});

export const setClearStateTimeout = () => {
  const expiry = getExpiry();
  if (expiry) {
    setTimeout(() => {
      store.dispatch(clearMapDetails());
    }, expiry);
  } else {
    store.dispatch(clearMapDetails());
  }
};

store.subscribe(() => {
  saveState(store.getState());
});
